import CreatMindItmeData from "../views/uidata/CreatMindItmeData";
import Strings from "./lang/strings";
import getString from "./lang/language";
import NodeLayoutType from "../viewmodel/datatype/NodeLayoutType";
import MindType from "../viewmodel/datatype/MindType";
import LineLayout from "../viewmodel/datatype/LineLayout";
import MindDisplayType from "../viewmodel/datatype/MindDisplayType";
import strings from "./lang/strings";
import CreateMapDatas from "./CreateMapDatas";

//创建导图的数据
var caseTemplateData = [];

function createdType() {    

    let createMapDatas = new CreateMapDatas()
    caseTemplateData = []
    caseTemplateData.push(createMapDatas.item1VerticalDatas)
    caseTemplateData.push(createMapDatas.item2VerticalDatas)
    caseTemplateData.push(createMapDatas.item3VerticalDatas)
    caseTemplateData.push(createMapDatas.item4VerticalDatas)
    caseTemplateData.push(createMapDatas.item5VerticalDatas)
    for (let i = 0; i < caseTemplateData.length; i++) {
      for (let j = 0; j < caseTemplateData[i].length; j++) {
        if (caseTemplateData[i][j] != null) {
          caseTemplateData[i][
            j
          ].icon = require("../assets/img/mindNewEditMenuIocn/oneKeyDiscoloration/template/" +
            caseTemplateData[i][j].icon);
        }
      }
    }
  }

  createdType();

export default caseTemplateData